import { useUIStore, type Screen } from "../../store/uiStore";
import { hapticFeedback } from "../../telegram/init";

const TABS: { screen: Screen; icon: string; label: string }[] = [
  { screen: "city",     icon: "\u{1F3DB}\uFE0F", label: "City" },
  { screen: "island",   icon: "\u{1F3DD}\uFE0F", label: "Island" },
  { screen: "research", icon: "\u{1F4DC}",        label: "Research" },
  { screen: "military", icon: "\u2694\uFE0F",     label: "Military" },
  { screen: "trade",    icon: "\u2693",            label: "Trade" },
];

export function BottomNav() {
  const currentScreen = useUIStore((s) => s.currentScreen);
  const setScreen = useUIStore((s) => s.setScreen);

  return (
    <nav style={{
      display: "flex",
      alignItems: "stretch",
      background: "linear-gradient(0deg, var(--parchment) 0%, var(--papyrus) 100%)",
      borderTop: "1.5px solid var(--sand)",
      paddingBottom: "var(--safe-bottom)",
      flexShrink: 0,
    }}>
      {TABS.map((tab) => {
        const isActive = currentScreen === tab.screen;
        return (
          <button
            key={tab.screen}
            onClick={() => {
              hapticFeedback("light");
              setScreen(tab.screen);
            }}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "2px",
              padding: "8px 4px 6px",
              background: "none",
              position: "relative",
              transition: "all 0.2s ease",
            }}
          >
            {/* Active indicator */}
            {isActive && (
              <span style={{
                position: "absolute",
                top: 0,
                left: "20%",
                right: "20%",
                height: "2.5px",
                borderRadius: "0 0 2px 2px",
                background: "linear-gradient(90deg, var(--gold), var(--gold-bright), var(--gold))",
                boxShadow: "0 1px 6px rgba(201, 169, 97, 0.4)",
              }} />
            )}
            <span style={{
              fontSize: "1.2rem",
              lineHeight: 1,
              filter: isActive ? "none" : "grayscale(0.6)",
              opacity: isActive ? 1 : 0.55,
              transition: "all 0.2s ease",
            }}>
              {tab.icon}
            </span>
            <span style={{
              fontFamily: "var(--font-display)",
              fontSize: "0.6rem",
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              fontWeight: isActive ? 700 : 500,
              color: isActive ? "var(--terra-dark)" : "var(--ink-faded)",
              transition: "all 0.2s ease",
            }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
